/**
 * Copyright (c) 2024 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */

export const setCurrentDocument = document => {
  return dispatch => {
    dispatch({
      type: 'SET_CURRENT_DOC',
      payload: document
    });
  };
};